(function (w) {
  'use strict';
  if (w.COClarityCommerce) return;
  w.COClarityCommerce = { initialized: true };
  var cartViewed = false;
  var privacyLoading = false;
  var cartPage = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(w.location.pathname);
  var readinessTimer = null, readinessAttempts = 0, hidden = false;

  function stopReadiness() {
    if (readinessTimer !== null) w.clearTimeout(readinessTimer);
    readinessTimer = null;
  }

  function retryReadiness() {
    if (!cartPage || cartViewed || hidden || readinessTimer !== null || readinessAttempts >= 20) return;
    readinessAttempts++;
    readinessTimer = w.setTimeout(function () {
      readinessTimer = null;
      initialize();
    }, 500);
  }

  function loadPrivacy() {
    if (typeof w.Shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function' || privacyLoading || typeof w.Shopify?.loadFeatures !== 'function') return;
    privacyLoading = true;
    try {
      w.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        privacyLoading = false;
        if (!error) viewCart();
      });
    } catch (_) { privacyLoading = false; }
  }

  function permitted() {
    try {
      return w.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch (_) { return false; }
  }

  function emit(name) {
    if (!permitted() || typeof w.clarity !== 'function') return false;
    try {
      w.clarity('event', name);
      return true;
    } catch (_) { return false; }
  }

  function viewCart() {
    if (!cartViewed && cartPage && !hidden) {
      cartViewed = emit('co_cart_viewed');
      if (cartViewed) stopReadiness();
    }
  }

  w.addEventListener('caroptions:cart-added', function () { initialize(); emit('co_add_to_cart'); });
  w.addEventListener('caroptions:checkout-starting', function () { initialize(); emit('co_checkout_requested'); });
  function initialize() {
    loadPrivacy();
    viewCart();
    retryReadiness();
  }
  w.addEventListener('pagehide', function () { hidden = true; stopReadiness(); });
  w.addEventListener('pageshow', function () { hidden = false; initialize(); });
  w.document.addEventListener('visitorConsentCollected', initialize);
  w.addEventListener('load', initialize, { once: true });
  initialize();
})(window);
